import { useState, useEffect, useRef } from "react";
import { Button, Select, DatePicker } from "antd";
// MonthRangePicker replaced by Antd DatePicker.RangePicker (picker="month")
import Select2Custom from "./Select2Custom";
import Api from "../services/api";
import moment from "moment";
import dayjs from "dayjs";

const FilterCohost2 = ({
                         startDate,
                         endDate,
                         handleChangeDate,
                         id,
                         onRunReport,
                         onMonthRangeChange, // <-- Nhận prop từ component cha
                       }) => {
  const [metricFilters, setMetricFilters] = useState("ad_revenue");

  const containerRef = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedName, setSelectedName] = useState(["Ad Revenue", "Ad ROAS"]);
  const [selectCountry, setSelectCountry] = useState([]);

  const [monthRange, setMonthRange] = useState({
    startDate: moment().subtract(5, "month"),
    endDate: moment(),
  });

  const handleRunReport = () => {
    const filterData = {
      startDate,
      endDate,
      selectedOptions,
      metricFilters,
      selectedName,
      from_month: monthRange?.startDate?.format("YYYY-MM"),
      to_month: monthRange?.endDate?.format("YYYY-MM"),
    };

    if (onRunReport) onRunReport(filterData);
  };

  const handleMetricChange = (value) => {
    setMetricFilters(value);
    const selectedNames = metricDisplayNames[value] || [
      "Ad Revenue",
      "Ad ROAS",
    ];
    setSelectedName(selectedNames);
  };

  const metric_array = [
    { key: "ad_revenue", name: "Ad Revenue" },
    { key: "iap_revenue", name: "IAP Revenue" },
    { key: "sub_revenue", name: "Subscription Revenue" },
    { key: "total_revenue", name: "Total Revenue" },
  ];

  const metricDisplayNames = {
    ad_revenue: ["Ad Revenue", "Ad ROAS"],
    iap_revenue: ["IAP Revenue", "IAP ROAS"],
    sub_revenue: ["Subscription Revenue", "Subscription ROAS"],
    total_revenue: ["Total Revenue", "Total ROAS"],
  };

  const handleMultiSelectChange = (val) => {
    setSelectedOptions(val.map((v) => v.value));
  };

  const handleMonthChange = (range) => {
    setMonthRange(range);

    // Gửi từ-tháng và đến-tháng về component cha
    if (onMonthRangeChange) {
      onMonthRangeChange(range);
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await Api.get(
            `/api/app/dimension_filter?dimension=country`
        );
        if (response?.data?.data) {
          const options = Array.isArray(response.data.data)
              ? response.data.data
              : [];
          setSelectCountry(options);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  return (
      <div className="p-3 filter-cohost2" ref={containerRef} data-popup-id={id} id={id}>
        <div className="row" style={{ marginBottom: "15px" }}>
          <div className="col-md-3">
            <h5>Installation Months</h5>
          </div>
          <div className="col-md-9">
            <div className="row filter-line">
              <div
                  className="col-md-3"
                  style={{ paddingLeft: "0px", paddingRight: "18px" }}
              >
                <DatePicker.RangePicker
                  picker="month"
                  allowClear={false}
                  format="YYYY-MM"
                  value={[dayjs(monthRange.startDate?.toDate ? monthRange.startDate.toDate() : monthRange.startDate), dayjs(monthRange.endDate?.toDate ? monthRange.endDate.toDate() : monthRange.endDate)]}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  dropdownClassName="drawer-date-dropdown"
                  onChange={(dates) => {
                    if (!dates || dates.length !== 2) return;
                    const [start, end] = dates;
                    const range = {
                      startDate: moment(start.toDate()),
                      endDate: moment(end.toDate())
                    };
                    setMonthRange(range);
                    if (onMonthRangeChange) onMonthRangeChange(range);
                  }}
                  style={{ width: '100%' }}
                />
              </div>
              <div
                  className="col-md-3"
                  style={{ paddingLeft: "0px", paddingRight: "18px" }}
              >
                <Select
                  mode="multiple"
                  value={(selectedOptions || []).map(v => v)}
                  onChange={(values) => {
                    const selected = (selectCountry || []).filter(opt => values.includes(opt.value || opt.code)).map(opt => ({
                      value: opt.value || opt.code,
                      label: opt.label || opt.name
                    }));
                    handleMultiSelectChange(selected);
                  }}
                  placeholder="Select country"
                  className="w-100"
                  allowClear
                  showSearch
                  filterOption={(input, option) => {
                    const label = option?.label || option?.children || '';
                    return label.toLowerCase().includes(input.toLowerCase());
                  }}
                >
                  {(selectCountry || []).map(opt => (
                    <Select.Option 
                      key={opt.value || opt.code}
                      value={opt.value || opt.code}
                      label={opt.label || opt.name}
                    >
                      {opt.label || opt.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginBottom: "15px" }}>
          <div className="col-md-3">
            <h5>Metric</h5>
          </div>
          <div className="col-md-9">
            <div className="row">
              <div
                  className="col-md-3"
                  style={{ paddingLeft: "0px", paddingRight: "18px" }}
              >
                <Select
                  value={metricFilters}
                  className="w-100"
                  onChange={(value) => handleMetricChange(value)}
                >
                  {metric_array.map((dim) => (
                    <Select.Option key={dim.key} value={dim.key}>
                      {dim.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginBottom: "15px" }}>
          <div className="col-md-3">
            <Button type="primary" onClick={handleRunReport}>Run Report</Button>
          </div>
        </div>
        <style>{`
          @media (max-width: 768px) {
            .filter-cohost2 .ant-row + .ant-row { margin-top: 10px !important; }
            .filter-cohost2 .filter-line > [class*="col-"] + [class*="col-"] { margin-top: 10px !important; }
            .filter-cohost2 .filter-line > .col + .col { margin-top: 10px !important; }
          }
        `}</style>
      </div>
  );
};

export default FilterCohost2;
